/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page-header{opacity:1;-ms-transform:translateY(0);transform:translateY(0);transition:transform ease .5s,opacity ease .5s}.page-header .brand{margin-top:10px}.page-header .brand img{width:200px;padding-top:5px}.is-inactive{opacity:0;-ms-transform:translateY(-100%);transform:translateY(-100%)}"];
export { styles as styles };
